/*
 * Get drug details
 */
import { clientFetch } from '../clientFetch';

export const getDrug = (drugId) => {
  return clientFetch(`/entity/drug/${drugId}`);
};
